import { type ActionItem } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type RowUser } from 'entities/Users/model/Table/RowUser'
import { MembersRoutes } from 'pages/settings/pages/members/route/type'

export const userProfile = (member: RowUser): ActionItem => {
  return {
    text: 'User profile',
    icon: 'userFilled',
    onAction: () => {
      uiStore.changeRouteViaVue({
        path: `/settings/members/${member.id}/${MembersRoutes.profile}`,
      })
    },
  }
}
